export default __webpack_public_path__ + "static/media/General_03_01.560070e5.jpg";